/**
 * 비로그인 감지 시 로그인 페이지로 보낼 search 를 만든다.
 * 현재 위치는 redirectPathAfterLogin 으로 감싸고, 부트 시 최상위 쿼리에서만 읽히는
 * 웹뷰 식별 파라미터(version/device)는 로그인 URL 최상위에 함께 보존한다.
 */
export const buildLoginRedirectSearchParams = (pathname: string, search: string) => {
  const params = new URLSearchParams({ redirectPathAfterLogin: pathname + search })

  // authDaemon 의 웹뷰 설정 분기는 version/device 가 모두 있을 때만 동작하므로 같은 조건으로 보존
  const currentParams = new URLSearchParams(search)
  const version = currentParams.get('version')
  const device = currentParams.get('device')
  if (version && device) {
    params.set('version', version)
    params.set('device', device)
  }

  return params
}
